interface Props {
  className?: string;
  compact?: boolean;
}

export function BrandMark({ className = '', compact = false }: Props) {
  if (compact) {
    return (
      <span
        className={`block whitespace-nowrap text-[0.88rem] font-extrabold tracking-[0.05em]
                    text-white/90 drop-shadow-[0_1px_8px_rgba(0,0,0,0.5)] ${className}`.trim()}
      >
        auto-scoreboard.com
      </span>
    );
  }

  return (
    <div className={`leading-tight ${className}`.trim()}>
      <p className="text-[0.7rem] font-semibold tracking-[0.04em] text-white/72">Auto-ScoreBoard</p>
      <p className="text-[0.65rem] text-white/45">auto-scoreboard.com</p>
    </div>
  );
}
